import { createAction } from '@reduxjs/toolkit';

const incrementCount = createAction('collections/incrementCount');

export default incrementCount;
